module.exports = __webpack_public_path__ + "static/media/bike-1.3f40c0cf.svg";